<template>
  <div class="FreeTicket_center">
    <indexTitle english_title="Free Ticket" chinese_title="免費索票" page='true'></indexTitle>
    <listbox :listbox='listbox' row="width:33.3%"></listbox>
    <div v-show="listbox.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
      <img src="../../assets/loading.gif">
    </div>
    <moreButton button_text="返回首頁" button_href="/"></moreButton>
  </div>
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
import listbox from '@/components/list/listbox'
import MoreButton from '@/components/index/MoreButton'
export default {
  components: {
    'indexTitle': IndexTitle,
    'listbox': listbox,
    'moreButton': MoreButton,
  },
  metaInfo: {
    title: '免費索票 │ TopLink 上聯國際展覽有限公司', // set a title
    meta: [{                 // set meta
      name: 'description',
      keywords: '上聯,展覽,免費,預約,門票',
      content: '上聯國際展覽免費贈票好康，特定期間將免費開放預約限量門票，有:旅遊展、寵物展、電腦展、加盟展、婦幼展、食品展、運動展、美容展、酒展、3C展、文具展、車展、建材展、家具展、素食展、茶展、佛展、電器展、珠寶展、健康展…等，數量有限送完為止。'
    }]
  },
  data() {
    return {
      listbox: []
    }
  },
  computed: {},
  created() {
    var vm = this;
    var free_api = process.env.VUE_APP_API + 'tlweb/free'
    this.axios.get(free_api)
      .then(function (response) {
        vm.listbox = response.data.data.data
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}
</script>
<style>
.FreeTicket_center {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  text-align: center;
}
</style>
